import React from 'react';
import { CleaveInput } from '@cp-shared-19/frontend-ui';

type YearInputProps = {
    label: string;
    name: string;
    isMandatory?: boolean;
    inputId?: string;
};

export const YearInput: React.FC<YearInputProps> = ({ label, name, isMandatory, inputId }) => {
    return (
        <CleaveInput
            requiredText=" *"
            className="c-form-field--no-floating"
            cleaveOptions={{
                delimiter: '',
                blocks: [4],
                numericOnly: true,
            }}
            inputMode={'numeric'}
            label={label}
            inputId={inputId}
            name={name}
            testId={`test-${name}`}
            isMandatory={isMandatory}
            required={isMandatory}
        />
    );
};
